import client from 'shared/ApiClient';
import { PaymentMethod, PaymentProduct, StripePaymentMethodKind } from './types';

const BASE = 'payment/api/payment-methods/';

export async function getPaymentMethods(): Promise<PaymentMethod[]> {
    return client(BASE);
}

export async function createSetupIntent(
    paymentMethodType: StripePaymentMethodKind,
): Promise<{ client_secret: string; setup_intent_id: string }> {
    return client(`${BASE}setup-intent/`, { body: { payment_method_type: paymentMethodType } });
}

export async function savePaymentMethod(
    stripePaymentMethodId: string,
    setupIntentStatus?: string,
    product: PaymentProduct = 'subs',
): Promise<PaymentMethod> {
    return client(BASE, {
        body: { payment_method_id: stripePaymentMethodId, setup_intent_status: setupIntentStatus, product },
    });
}

export async function setDefaultPaymentMethod(id: number): Promise<PaymentMethod> {
    return client(`${BASE}${id}/set-default/`, { method: 'POST' });
}

export async function setRecruitDefaultPaymentMethod(id: number): Promise<PaymentMethod> {
    return client(`${BASE}${id}/set-recruit-default/`, { method: 'POST' });
}

export async function deletePaymentMethod(id: number): Promise<void> {
    return client(`${BASE}${id}/`, { method: 'DELETE' });
}

export async function assignAddressesToPaymentMethod(id: number, addressIds: number[]): Promise<PaymentMethod> {
    return client(`${BASE}${id}/assign-addresses/`, { body: { address_ids: addressIds } });
}

export async function unassignAddressesFromPaymentMethod(id: number, addressIds: number[]): Promise<PaymentMethod> {
    return client(`${BASE}${id}/unassign-addresses/`, { body: { address_ids: addressIds } });
}
